import { createFileRoute, redirect } from "@tanstack/react-router";

/** Alias: /store/:storeId → /stores/:storeId */
export const Route = createFileRoute("/_authenticated/store/$storeId")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/stores/$storeId", params: { storeId: params.storeId } });
  },
});
